import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FontAwesomeService} from '@services/font-awesome.service';
import {SHIPMENTS_LOAD} from '@store/actions';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {Store} from '@ngrx/store';
import {AccountService} from '@services/account.service';
import {AppState, selectBookedShipments} from '@store/reducers';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute} from '@angular/router';
import {ShipmentHistory} from '@models/shipment-history.interface';
import {ShipmentStatus} from '@models/shipment-status.enum';
import {ShipmentStatusService} from '@services/shipment-status.service';

@Component({
  selector: 'app-additional-costs',
  templateUrl: './additional-costs.component.html',
  styleUrls: ['./additional-costs.component.scss']
})
export class AdditionalCostsComponent implements OnInit , OnChanges {
  @Input() shipment: any;
  subscription: Subscription;
  id: number;
  total: number;
  sourceShipments: any[];
  card_type: number;
  card_number: number;
  paymentMethod: number;
  pageSize = 3;
  constructor(
    public faService: FontAwesomeService,
    private activateRoute: ActivatedRoute,
    private accountService: AccountService,
    public shipmentStatusService: ShipmentStatusService,
    private store: Store<AppState>
  ) {}
  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.shipment) {
      this.shipment = changes.shipment.currentValue;
      this.total = 0;
      if (this.shipment.extra_charges.length > 0) {
        for (let i in this.shipment.extra_charges) {
          this.total = this.total + (this.shipment.extra_charges[i].total - 0);
          this.card_type = this.shipment.extra_charges[i].payment.card_type;
          this.card_number = this.shipment.extra_charges[i].payment.card_number;
          this.paymentMethod = this.shipment.extra_charges[i].payment.method;
        }
      }

    }

  }

  applyFilter(data) {
  }
  getColorByIndex(statusIndex: number) {
    let status: ShipmentStatus;
    switch (statusIndex) {
      case 0: status = ShipmentStatus.CREATED; break;
      case 1: status = ShipmentStatus.CONFIRMED; break;
      case 2: status = ShipmentStatus.PICKUP; break;
      case 3: status = ShipmentStatus.DELIVERED; break;
      case 4: status = ShipmentStatus.FAILED; break;
    }
    return this.shipmentStatusService.getColorByStatus(ShipmentStatus[status]);
  }

  getColorByStatusName(status: string) {
    return this.shipmentStatusService.getColorByStatus(ShipmentStatus[status]);
  }

  printReceipts() {

  }
}




// WEBPACK FOOTER //
// ./src/app/modules/shipments/components/additional-costs/additional-costs.component.ts